{
  "en": {
    "sublines": {
      "hangarGuide": {
        "headline": "maybe we should change that ;)",
        "add": "How to add a ship?",
        "edit": "How to edit a ship?",
        "wishlist": "How to add a ship to your wishlist?",
        "fleetchart": "Fleetchart?",
        "public": "Public URL?",
        "groups": "How to create and update groups?"
      },
      "impressum": {
        "general": "General Information (according to § 5 TMG)",
        "disclaimer": "Disclaimer",
        "copyright": "Copyright",
        "thirdpartycontent": "Credits",
        "sponsors": "Sponsors",
        "liabilityInternal": "Limitation of liability for internal content",
        "liabilityExternal": "Limitation of liability for external links"
      },
      "settings": {
        "rsiData": "RSI Information"
      }
    }
  }
}
